export default "__VITE_ASSET__CqG_Q1SJ__"